"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = void 0;
var _registration = require("../../types/registration");
const defaultState = exports.defaultState = {
  register: {
    status: _registration.ERegisterStatus.Initial
  },
  sendSms: {
    status: _registration.ESendSmsStatus.Initial
  },
  confirmPhone: {
    status: _registration.EConfirmPhoneStatus.Initial
  },
  isProfessionalUser: false
};